module.exports = __webpack_public_path__ + "cf.36a24f21c09f2ed10750.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/cf.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/cf.svg
// module chunks = styles